module.exports = __webpack_public_path__ + "static/media/Husky909_1c.d66fcdc3.svg";